import Axios from 'axios';
import { User, Address } from '../types';

export const SET_USER = 'SET_USER';
export function setUser(user: User) {
  return {
    type: SET_USER,
    payload: { user },
  };
}

export const REMOVE_USER = 'REMOVE_USER';
export function removeUser() {
  return {
    type: REMOVE_USER,
  };
}

export const ADD_USER_ADDRESS = 'ADD_USER_ADDRESS';
export function addUserAddress(address: Address) {
  return {
    type: ADD_USER_ADDRESS,
    payload:  {address} ,
  };
}


export const SET_USERS_FOLLOW = 'SET_USERS_FOLLOW';
export function setUsersFollow(usersId: number[]) {
  return {
    type: SET_USERS_FOLLOW,
    payload: { usersId },
  };
}


export const REMOVE_USER_FOLLOW = 'REMOVE_USER_FOLLOW';
export function removeUserFollow(userId: number) {
  return {
    type: REMOVE_USER_FOLLOW,
    payload: { userId },
  };
}

export const ADD_USER_FOLLOW = 'ADD_USER_FOLLOW';
export function addUserFollow(userId: number) {
  return {
    type: ADD_USER_FOLLOW,
    payload: { userId },
  };
}


export function loginLocally(token: string) {
  localStorage.setItem('loginToken',token);
  Axios.defaults.headers.common.token = token;
}

export function setAxiosToken(token: string) {
  // localStorage.setItem('loginToken', JSON.stringify(token));
  Axios.defaults.headers.common.token = token;
}


export function logoutLocally() {
  localStorage.removeItem('loginToken');
  localStorage.setItem('cart', '[]');
  delete Axios.defaults.headers.common.token;
  return {
    type: 'logout',
  };
}
